var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _g3, _g4, _path7, _g5, _g6, _path8, _g7, _g8, _path9, _path10;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreeneyeG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 496,
    viewBox: "0 0 512 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6287 35.3144C70.6287 15.8108 54.8179 0 35.3144 0C15.8108 0 0 15.8108 0 35.3144V460.518C0 480.022 15.8108 495.833 35.3144 495.833C54.8179 495.833 70.6287 480.022 70.6287 460.518V35.3144Z",
    fill: "#343746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.001 35.3144C512.001 15.8108 496.19 0 476.686 0C457.183 0 441.372 15.8108 441.372 35.3144V460.518C441.372 480.022 457.183 495.833 476.686 495.833C496.19 495.833 512.001 480.022 512.001 460.518V35.3144Z",
    fill: "#343746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.832 94.3698C182.832 74.8662 167.021 59.0554 147.517 59.0554C128.014 59.0554 112.203 74.8662 112.203 94.3698V401.462C112.203 420.965 128.014 436.776 147.517 436.776C167.021 436.776 182.832 420.965 182.832 401.462V94.3698Z",
    fill: "#343746"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M401.641 94.3698C401.641 74.8662 385.831 59.0554 366.327 59.0554C346.823 59.0554 331.013 74.8662 331.013 94.3698V401.462C331.013 420.965 346.823 436.776 366.327 436.776C385.831 436.776 401.641 420.965 401.641 401.462V94.3698Z",
    fill: "#343746"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.285 163.21C291.285 143.706 275.474 127.895 255.971 127.895C236.467 127.895 220.656 143.706 220.656 163.21V332.683C220.656 352.186 236.467 367.997 255.971 367.997C275.474 367.997 291.285 352.186 291.285 332.683V163.21Z",
    fill: "#343746"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M70.6287 83.5143C70.6287 64.0107 54.8179 48.2 35.3144 48.2C15.8108 48.2 0 64.0107 0 83.5143V412.678C0 432.181 15.8108 447.992 35.3144 447.992C54.8179 447.992 70.6287 432.181 70.6287 412.678V83.5143Z",
    fill: "#1EB6DB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M70.6287 245.59C70.6287 226.086 54.8179 210.275 35.3144 210.275C15.8108 210.275 0 226.086 0 245.59V412.677C0 432.18 15.8108 447.991 35.3144 447.991C54.8179 447.991 70.6287 432.18 70.6287 412.677V245.59Z",
    fill: "#1EB6DB"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6287 245.59C70.6287 226.086 54.8179 210.275 35.3144 210.275C15.8108 210.275 0 226.086 0 245.59V319.38C0 338.884 15.8108 354.694 35.3144 354.694C54.8179 354.694 70.6287 338.884 70.6287 319.38V245.59Z",
    fill: "#1EB6DB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M511.998 83.5141C511.998 64.0105 496.187 48.1997 476.684 48.1997C457.18 48.1997 441.369 64.0105 441.369 83.5141V412.677C441.369 432.181 457.18 447.992 476.684 447.992C496.187 447.992 511.998 432.181 511.998 412.677V83.5141Z",
    fill: "#1EB6DB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M511.998 83.5141C511.998 64.0105 496.187 48.1997 476.684 48.1997C457.18 48.1997 441.369 64.0105 441.369 83.5141V250.601C441.369 270.105 457.18 285.915 476.684 285.915C496.187 285.915 511.998 270.105 511.998 250.601V83.5141Z",
    fill: "#1EB6DB"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512.001 176.81C512.001 157.307 496.19 141.496 476.686 141.496C457.183 141.496 441.372 157.307 441.372 176.81V250.601C441.372 270.104 457.183 285.915 476.686 285.915C496.19 285.915 512.001 270.104 512.001 250.601V176.81Z",
    fill: "#1EB6DB"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M182.834 141.377C182.834 121.873 167.023 106.062 147.519 106.062C128.016 106.062 112.205 121.873 112.205 141.377V352.726C112.205 372.23 128.016 388.041 147.519 388.041C167.023 388.041 182.834 372.23 182.834 352.726V141.377Z",
    fill: "#1EB6DB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M182.834 141.377C182.834 121.873 167.023 106.062 147.519 106.062C128.016 106.062 112.205 121.873 112.205 141.377V264.381C112.205 283.884 128.016 299.695 147.519 299.695C167.023 299.695 182.834 283.884 182.834 264.381V141.377Z",
    fill: "#1EB6DB"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.832 141.377C182.832 121.873 167.021 106.062 147.517 106.062C128.014 106.062 112.203 121.873 112.203 141.377V215.167C112.203 234.671 128.014 250.482 147.517 250.482C167.021 250.482 182.832 234.671 182.832 215.167V141.377Z",
    fill: "#1EB6DB"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M401.644 141.377C401.644 121.873 385.834 106.062 366.33 106.062C346.826 106.062 331.016 121.873 331.016 141.377V352.726C331.016 372.23 346.826 388.041 366.33 388.041C385.834 388.041 401.644 372.23 401.644 352.726V141.377Z",
    fill: "#1EB6DB"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M401.644 229.783C401.644 210.279 385.834 194.468 366.33 194.468C346.826 194.468 331.016 210.279 331.016 229.783V352.786C331.016 372.29 346.826 388.101 366.33 388.101C385.834 388.101 401.644 372.29 401.644 352.786V229.783Z",
    fill: "#1EB6DB"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.641 278.996C401.641 259.492 385.831 243.682 366.327 243.682C346.823 243.682 331.013 259.492 331.013 278.996V352.786C331.013 372.29 346.823 388.101 366.327 388.101C385.831 388.101 401.641 372.29 401.641 352.786V278.996Z",
    fill: "#1EB6DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.285 202.043C291.285 182.539 275.474 166.729 255.971 166.729C236.467 166.729 220.656 182.539 220.656 202.043V275.833C220.656 295.337 236.467 311.148 255.971 311.148C275.474 311.148 291.285 295.337 291.285 275.833V202.043Z",
    fill: "#1EB6DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeneyeG);
export default __webpack_public_path__ + "static/media/greeneyeG.07d68556cd88b6086de718f80ded91c6.svg";
export { ForwardRef as ReactComponent };